export default __webpack_public_path__ + "static/media/pane2bg.1a2935b9.png";